import { render, staticRenderFns } from "./reminder-list-component.vue?vue&type=template&id=6edd2560&"
import script from "./reminder-list-component.vue?vue&type=script&lang=ts&"
export * from "./reminder-list-component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports